import React from 'react'
import PropTypes from 'prop-types'

// material-ui components
import { makeStyles } from '@material-ui/core/styles'
import styles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js'
import FormControl from '@material-ui/core/FormControl'
import Tooltip from '@material-ui/core/Tooltip'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

// core components
import GridContainer from '../../components/Grid/GridContainer.js'
import GridItem from '../../components/Grid/GridItem.js'

const useStyles = makeStyles(styles)

export default function SiteSelector ({ siteList, onSelect, isGridItem, showAllSitesOption, autoSelect, initialSite, disabled = false, disabledTooltipText = '' }) {
  const [site, setSite] = React.useState('')
  const [gridItem, setGridItem] = React.useState(true)

  const sitesUpdated = () => {
    if (isGridItem !== undefined || isGridItem !== null) {
      setGridItem(isGridItem)
    }
  }

  React.useEffect(sitesUpdated, [])

  const handleSite = event => {
    setSite(event.target.value)
  }

  // if the site changes fire the onSelect event if it's defined
  React.useEffect(() => {
    if (onSelect && site !== '') {
      onSelect(site)
    }
  }, [site])

  // on initial page load, if we have autoSelect enabled, and displaying of all sites, trigger selection of 'All Sites' option
  React.useEffect(() => {
    if (showAllSitesOption && autoSelect) {
      handleSite({ target: { value: 'all' } })
    }
  }, [])

  // when the site list is loaded, if we have autoSelect enabled, but NOT showAllSitesOption, then load then trigger select for first site in the list
  React.useEffect(() => {
    if (siteList && siteList.length > 0 && autoSelect && !showAllSitesOption) {
      handleSite({ target: { value: siteList[0].id } })
    }

    // once the site list is loaded, if we have been passed an initial site to be selected, select it
    if (siteList && siteList.length > 0 && initialSite !== null) {
      let siteFound = false

      for (const site of siteList) {
        if (site.id === initialSite) {
          siteFound = true
          break
        }
      }

      if (siteFound) {
        setSite(initialSite)
      }
    }
  }, [siteList])

  const mainComponent = () => {
    return (
      <FormControl fullWidth className={classes.selectFormControl} style={{ marginTop: 0 }}>
        <InputLabel shrink htmlFor="site-select" className={classes.selectLabel}>
        Sites
        </InputLabel>
        <Tooltip disableHoverListener={!disabled} disableFocusListener={true} arrow title={disabledTooltipText}>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={site}
            onChange={handleSite}
            displayEmpty
            inputProps={{
              name: 'site',
              id: 'site-select'
            }}
            disabled={disabled}
          >
            <MenuItem
              disabled
              classes={{
                root: classes.selectMenuItem
              }}
              value=""
            >
            Choose Site
            </MenuItem>
            {
              showAllSitesOption &&
              <MenuItem
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected
                }}
                value="all">
                All Sites
              </MenuItem>
            }
            { siteList && siteList.map(site => (
              <MenuItem
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected
                }}
                value={site.id}
                key={site.id}
              >
                {site.name}
              </MenuItem>
            ))}
          </Select>
        </Tooltip>
      </FormControl>)
  }

  const classes = useStyles()

  return (
    <>
      {gridItem
        ? <GridContainer>
          <GridItem xs={12}>
            {
              mainComponent()
            }
          </GridItem>
        </GridContainer>
        : mainComponent()
      }
    </>)
}

SiteSelector.propTypes = {
  siteList: PropTypes.array,
  onSelect: PropTypes.func,
  isGridItem: PropTypes.bool,
  showAllSitesOption: PropTypes.bool,
  autoSelect: PropTypes.bool,
  initialSite: PropTypes.string,
  disabled: PropTypes.bool,
  disabledTooltipText: PropTypes.string
}
